import React, { useEffect, useState, useCallback } from "react";
import "./Serviceimage.css";

export default function Serviceimage() {
  const images = [
    `${process.env.PUBLIC_URL}/IMG_7813.jpg`,
    `${process.env.PUBLIC_URL}/IMG_24631.jpg`,
    `${process.env.PUBLIC_URL}/IMG_25301.jpg`,
    `${process.env.PUBLIC_URL}/IMG_25451.jpg`,
    `${process.env.PUBLIC_URL}/IMG_36481.jpg`,
    `${process.env.PUBLIC_URL}/IMG_36491(2).jpg`,
    `${process.env.PUBLIC_URL}/IMG_36761.jpg`,

    `${process.env.PUBLIC_URL}/IMG_37521(4).jpg`,
    `${process.env.PUBLIC_URL}/IMG_38191.jpg`,
    `${process.env.PUBLIC_URL}/IMG_38881.jpg`,
    `${process.env.PUBLIC_URL}/IMG_50621.jpg`,
    `${process.env.PUBLIC_URL}/IMG_50651.jpg`,
    `${process.env.PUBLIC_URL}/Resized_20250909_112907.jpeg`,
    `${process.env.PUBLIC_URL}/Resized_20250909_115422.jpeg`,

    `${process.env.PUBLIC_URL}/IMG_25451.jpg`,
    `${process.env.PUBLIC_URL}/cn-2.jpg`,
    `${process.env.PUBLIC_URL}/cn-3.jpg`,
    `${process.env.PUBLIC_URL}/cn-4.jpg`,
    `${process.env.PUBLIC_URL}/cn-5.jpg`,
    `${process.env.PUBLIC_URL}/cn-7.jpg`,
    `${process.env.PUBLIC_URL}/cn-8.jpg`,
    `${process.env.PUBLIC_URL}/cn-9.jpg`,
    `${process.env.PUBLIC_URL}/cn-10.jpg`,
    `${process.env.PUBLIC_URL}/MG-CN.jpg`,

    `${process.env.PUBLIC_URL}/c1.jpg`,
    `${process.env.PUBLIC_URL}/c2.jpg`,
    `${process.env.PUBLIC_URL}/c3.jpg`,
    `${process.env.PUBLIC_URL}/c4.jpg`,
    `${process.env.PUBLIC_URL}/c5.jpg`,
    `${process.env.PUBLIC_URL}/c6.jpg`,
    `${process.env.PUBLIC_URL}/c7.jpg`,
    `${process.env.PUBLIC_URL}/c8.jpg`,
    `${process.env.PUBLIC_URL}/c9.jpg`,
    `${process.env.PUBLIC_URL}/c10.jpg`,

    `${process.env.PUBLIC_URL}/c20.jpg`,
    `${process.env.PUBLIC_URL}/c21.jpg`,
    `${process.env.PUBLIC_URL}/c23.jpg`,
    `${process.env.PUBLIC_URL}/c25.jpg`,


    `${process.env.PUBLIC_URL}/TRUCKONE.jpg`,
    `${process.env.PUBLIC_URL}/WORK.jpg`,

    `${process.env.PUBLIC_URL}/new1.jpg`,
    `${process.env.PUBLIC_URL}/New2.jpg`,
    `${process.env.PUBLIC_URL}/new3.jpg`,
    `${process.env.PUBLIC_URL}/new5.jpg`,

    `${process.env.PUBLIC_URL}/p1.jpg`,
    `${process.env.PUBLIC_URL}/p2.jpg`,
    `${process.env.PUBLIC_URL}/p3.jpg`,
    `${process.env.PUBLIC_URL}/p4.jpg`,
    `${process.env.PUBLIC_URL}/p5.jpg`,

    `${process.env.PUBLIC_URL}/p6.jpg`,
    `${process.env.PUBLIC_URL}/p7.jpg`,
    `${process.env.PUBLIC_URL}/p8.jpg`,



    `${process.env.PUBLIC_URL}/s1.jpg`,
    `${process.env.PUBLIC_URL}/s2.jpg`,
    `${process.env.PUBLIC_URL}/s3.jpg`,
    `${process.env.PUBLIC_URL}/s4.jpg`,

    `${process.env.PUBLIC_URL}/s5.jpg`,
    `${process.env.PUBLIC_URL}/s6.jpg`,
    `${process.env.PUBLIC_URL}/s7.jpg`,
    `${process.env.PUBLIC_URL}/s8.jpg`,





  ];

  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});
  const [isZoomed, setIsZoomed] = useState(false);

  const openLightbox = useCallback((i) => {
    setIndex(i);
    setOpen(true);
    setIsZoomed(false);
  }, []);

  const closeLightbox = useCallback(() => {
    setOpen(false);
    setIsZoomed(false);
  }, []);

  const next = useCallback((e) => {
    e?.stopPropagation();
    setIndex((i) => (i + 1) % images.length);
    setIsZoomed(false);
  }, [images.length]);

  const prev = useCallback((e) => {
    e?.stopPropagation();
    setIndex((i) => (i - 1 + images.length) % images.length);
    setIsZoomed(false);
  }, [images.length]);

  const toggleZoom = useCallback((e) => {
    e?.stopPropagation();
    setIsZoomed(prev => !prev);
  }, []);

  const handleImageLoad = useCallback((imgIndex) => {
    setLoadedImages(prev => ({ ...prev, [imgIndex]: true }));
  }, []);

  // Keyboard navigation and effects
  useEffect(() => {
    const onKey = (e) => {
      if (!open) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
      if (e.key === " " || e.key === "z") {
        e.preventDefault();
        toggleZoom();
      }
    };

    document.addEventListener("keydown", onKey);

    if (open) {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px"; // Prevent layout shift
    }

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [open, closeLightbox, next, prev, toggleZoom]);

  // Preload next and previous images for lightbox
  useEffect(() => {
    if (open) {
      const preloadImages = [
        images[(index - 1 + images.length) % images.length],
        images[(index + 1) % images.length]
      ];

      preloadImages.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    }
  }, [open, index, images]);

  return (
    <section className="service-gallery" aria-label="Project gallery">
      {/* Gallery Header */}
      <div className="gallery-header">
        <div className="gallery-container">
          <h2 className="gallery-title">Our Project Gallery</h2>
          <div className="gallery-underline"></div>
        </div>
      </div>

      {/* Main Gallery Grid */}
      <div className="gallery-container">
        <div className="gallery-grid">
          {images.map((src, i) => (
            <div key={i} className="gallery-item">
              <button
                className="gallery-card"
                onClick={() => openLightbox(i)}
                aria-label={`View image ${i + 1} in full screen`}
              >
                <div className="card-image-container">
                  <img
                    className={`card-image ${loadedImages[i] ? 'loaded' : ''}`}
                    src={src}
                    alt={`Project image ${i + 1}`}
                    loading="lazy"
                    onLoad={() => handleImageLoad(i)}
                  />
                  {!loadedImages[i] && <div className="image-skeleton"></div>}
                </div>
                <div className="card-overlay">
                  <div className="overlay-content">
                    <svg className="zoom-icon" viewBox="0 0 24 24" fill="none">
                      <path d="M15 15L21 21M10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17Z" stroke="currentColor" strokeWidth="2" />
                    </svg>
                    <span className="image-number">{i + 1}</span>
                  </div>
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {open && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-backdrop"></div>

          {/* Header Controls */}
          <div className="lightbox-header">
            <button
              className="lightbox-close"
              onClick={(e) => { e.stopPropagation(); closeLightbox(); }}
              aria-label="Close lightbox"
            >
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" />
              </svg>
            </button>

            <div className="lightbox-info">
              <span className="image-counter">
                {index + 1} / {images.length}
              </span>
            </div>

            <button
              className="lightbox-zoom"
              onClick={toggleZoom}
              aria-label={isZoomed ? "Zoom out" : "Zoom in"}
            >
              <svg viewBox="0 0 24 24" fill="none">
                {isZoomed ? (
                  <path d="M8 16L16 8M8 8L16 16" stroke="currentColor" strokeWidth="2" />
                ) : (
                  <path d="M8 8H16V16" stroke="currentColor" strokeWidth="2" />
                )}
              </svg>
            </button>
          </div>

          {/* Navigation Controls */}
          <button
            className="lightbox-nav lightbox-prev"
            onClick={prev}
            aria-label="Previous image"
          >
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" />
            </svg>
          </button>

          <button
            className="lightbox-nav lightbox-next"
            onClick={next}
            aria-label="Next image"
          >
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" />
            </svg>
          </button>

          {/* Main Image */}
          <div className="lightbox-content" onClick={toggleZoom}>
            <img
              className={`lightbox-image ${isZoomed ? 'zoomed' : ''}`}
              src={images[index]}
              alt={`Project image ${index + 1}`}
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          {/* Thumbnail Strip */}
          <div className="lightbox-thumbnails">
            {images.map((src, i) => (
              <button
                key={i}
                className={`thumbnail ${i === index ? 'active' : ''}`}
                onClick={(e) => { e.stopPropagation(); setIndex(i); }}
                aria-label={`Go to image ${i + 1}`}
              >
                <img src={src} alt="" />
              </button>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}